import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-WMGXGBXBQL";

/**
 * Fires a Google Analytics page_view on every React Router location change.
 * Required for SPAs because gtag only fires once on initial load.
 */
export default function RouteTracker() {
  const loc = useLocation();
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("config", GA_ID, {
      page_path: loc.pathname + loc.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [loc.pathname, loc.search]);
  return null;
}

/** Convenience helper for custom events (e.g., lead form submit, invoice paid) */
export function trackEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}
